import { Component, OnInit,Output,EventEmitter } from '@angular/core';
import { Router } from '@angular/router';



@Component({
  selector: 'app-main',
  templateUrl: '../views/main.component.html',
  styleUrls: ['../../../css/main.component.css']
})
export class MainComponent implements OnInit {
  
  public payObject : any;

  @Output() startQustionPaper: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private router: Router
  ) {
  }

  ngOnInit() {
    // ?success=true&type=payment
    //this.startQustionPaper.emit(true);
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-sets/components/main.component.ts